export function calculateStepScore(correctCount: number, stackLength: number): number {
  if (!Number.isFinite(stackLength) || stackLength <= 0) return 0;
  if (!Number.isFinite(correctCount) || correctCount <= 0) return 0;

  return Math.ceil((correctCount / stackLength) * 100);
}
